export const doesWindowExist = () => {
  return typeof window !== 'undefined';
};
